import { Record, List } from 'immutable';

const ReaderResultRecord = Record({
  studentId: undefined,
  completion: undefined,
});

class ReaderResult extends ReaderResultRecord { }

const ReaderResultReviver = ([key, item]) => {
  if (! item) return [key, item];
  switch (key) {
    case 'completion':
      return [key, Number.parseInt(item, 10)];
    case 'studentId':
      return [key, `${item}`];
    default:
      [key, item];
  }
};

ReaderResult.create = (data) => new ReaderResult(data).mapEntries(ReaderResultReviver);

const AssignedReaderRecord = Record({
  sessionId: undefined,
  unitId: undefined,
  lessonNumber: undefined,
  unitOrderingSequence: undefined,
  studentAssignedReaderResults: new List(),
});

class AssignedReader extends AssignedReaderRecord { }

const reviver = ([key, item]) => {
  if (! item) return [key, item];
  switch (key) {
    case 'lessonNumber':
      return [key, Number.parseInt(item, 10)];
    case 'sessionId':
    case 'unitId':
      return [key, `${item}`];
    case 'studentAssignedReaderResults':
      return [key, new List(item.map((readerResult) => ReaderResult.create(readerResult)))];
    default:
      [key, item];
  }
};

AssignedReader.create = (data) => new AssignedReader(data).mapEntries(reviver);

export default AssignedReader;



// WEBPACK FOOTER //
// ./data/Reader/AssignedReader/model.js